import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {PortvisitUtils} from '../../../refdata/portvisit-utils';
import {
  ApiCustomer,
  CommercialReleaseSummary,
  FindCustomers,
  GetMyCarriers,
  IE3ConsignmentProcessSummary,
  ReleaseToParty
} from '@portbase/bezoekschip-service-typescriptmodels';
import {AppContext} from "../../../app-context";
import lodash, {toUpper} from 'lodash';
import {of} from 'rxjs';
import {sendQuery} from '../../../common/utils';
import {map} from 'rxjs/operators';
import {terminalOrganisationName, terminals} from "../../commercial-release.utils";
import {VisitContext} from "../../../visit-details/visit-context";

@Component({
    selector: 'app-commercial-release-details',
    templateUrl: './commercial-release-details.component.html',
    styleUrls: ['./commercial-release-details.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CommercialReleaseDetailsComponent {
  refData = PortvisitUtils;
  appContext = AppContext;
  @Input() summary: CommercialReleaseSummary;

  selectedConsignment: IE3ConsignmentProcessSummary;

  selectConsignment(entity: IE3ConsignmentProcessSummary) {
    delete this.summary.releaseData.equipmentNumber;
    this.selectedConsignment = entity;
    this.summary.releaseData.consignmentNumber = toUpper(entity?.masterConsignment?.consignmentNumber);
    this.summary.releaseData.terminalShortName = entity?.masterConsignment?.dischargeTerminal?.organisationShortName;
    delete this.summary.releaseData.containerOperator;
    this.summary.releaseData.empty = entity?.masterConsignment?.equipments?.every(e => e.empty);
    this.summary.crn = entity?.crn;
  }

  containersInConsignment = (summary: IE3ConsignmentProcessSummary) => {
    return of(summary ? lodash.uniq(lodash.flatMap(
      summary.straight ? summary.masterConsignment?.houseConsignments[0].goodsItems : summary.masterConsignment.goodsItems, g => g.placements)
      .map(p => p.containerIdentificationNumber)) : []);
  }

  carriersProvider = (iamConnectedId: string) => sendQuery(
    "com.portbase.bezoekschip.common.api.visit.GetMyCarriers", <GetMyCarriers>{
      cargoDeclarantIamConnectedId: iamConnectedId || AppContext.userProfile.organisation?.iamConnectedId
    });

  findReleaseToParties = term => {
    const ownerShortName = (AppContext.isAdmin() && this.summary.releaseData?.containerOperator?.cargoDeclarantShortName)
      || AppContext.userProfile.organisation?.shortName;
    return sendQuery(
      "com.portbase.bezoekschip.common.api.commercialrelease.FindCustomers",
      <FindCustomers>{
        term: term,
        ownerShortName: ownerShortName
      }
    )
      .pipe(map((results: ApiCustomer[]) => {
        return lodash.flatMap(results, r => lodash.values(r.references).map(customerRef => <ReleaseToParty>{
          name: r.customerData?.fullName,
          portbaseId: r.portbaseId,
          customerReference: customerRef.reference
        }));
      }));
  };
  protected readonly terminals = terminals;

  protected readonly terminalOrganisationName = terminalOrganisationName;
  protected readonly context = VisitContext;
}
